import { React, DomeRouter, DomeComponent } from '@lexriver/dome'
import { UrlGenerator } from '../UrlGenerator';

interface Attrs {
    class?: Object | string[] | string
    fallbackUrl?: string
    hideLinkIfNoPreviousUrl?: boolean
}

export class LinkBack extends DomeComponent<Attrs>{
    render() {
        // return <a tabindex={0} class={attrs.class} onClick={(e) => {e.preventDefault(); history.go(-1)}}>{children}</a>
        //const currentUrl = DomeRouter.getCurrentUrl()
        let previousUrl = DomeRouter.getPreviousPageUrl(0)

        if (this.attrs.hideLinkIfNoPreviousUrl && !previousUrl) {
            return null
        }

        return <a
            // href="#"
            tabindex={0}
            class={this.attrs.class}
            onClick={(e) => {
                e.preventDefault();
                // DomeRouter.navigate(previousUrl ?? this.attrs.fallbackUrl ?? UrlGenerator.home)
                history.go(-1)

                // if(previousUrl){
                //     history.go(-1)
                // } else {
                //     DomeRouter.navigate(this.attrs.fallbackUrl ?? UrlGenerator.home)
                // }
            }}>{this.children}</a>
    }
}